import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Controlled } from "react-codemirror2";
import { ModalBody, Button, Modal, ModalHeader, ModalFooter } from "reactstrap";
import { IoLogoHtml5 } from "react-icons/io";
import { toast } from "react-toastify";
import { MdOutlineCopyAll, MdDownload } from "react-icons/md";

export default function ExportModal({ isOpen, onClose, exportContent }) {
  const download = () => {
    const element = document.createElement("a");
    const file = new Blob([exportContent], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "codePlay.html";
    document.body.appendChild(element);
    element.click();
  };
  return (
    <div>
      <Modal
        className="export-modal"
        size={"xl"}
        centered
        scrollable
        isOpen={isOpen}
        toggle={onClose}
      >
        <ModalHeader toggle={onClose}>Export as HTML</ModalHeader>
        <ModalBody className="pt-0 pb-0">
          <div className="title">
            <IoLogoHtml5 size={20} style={{ color: "#e34c26" }} />
          </div>
          <Controlled
            value={exportContent}
            className="code-mirror-wrapper"
            options={{
              lineWrapping: true,
              lint: true,
              mode: "xml",
              theme: "dracula",
              lineNumbers: true,
              smartIndent:true,
              electricChars:true,
              readOnly:true
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              navigator.clipboard.writeText(exportContent);
              toast.success("Copied to ClipBoard", {
                position: "bottom-center",
                theme: "dark",
                hideProgressBar: true,
                autoClose: 1000,
              });
              onClose();
            }}
          >
            <MdOutlineCopyAll size={20} /> Copy
          </Button>
          <Button
            color="success"
            onClick={() => {
              download();
              onClose();
            }}
          >
            <MdDownload size={20} /> Download
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
